import ChargeProcessesList from "./ChargeProcessesList";

export default {
    list: ChargeProcessesList
};
